module.exports = __webpack_public_path__ + "static/media/fa-brands-400.5063b105.eot";